import { useMemo } from 'react';
import { useStore } from '@/providers/StoreProvider';

export function useActiveFiltersCount() {
  const price = useStore(s => s.listingsFilters.price);
  const bedrooms = useStore(s => s.listingsFilters.bedrooms);
  const minNumBathrooms = useStore(s => s.listingsFilters.minNumBathrooms);
  const buildingStatus = useStore(s => s.listingsFilters.buildingStatus);
  const expectedMoveInDate = useStore(s => s.listingsFilters.expectedMoveInDate);
  const amenities = useStore(s => s.listingsFilters.amenities);
  const compliances = useStore(s => s.listingsFilters.compliances);

  const activeFilterCount = useMemo(() => {
    let count = 0;

    // Price filter
    if (price.min !== null || price.max !== null) count++;

    // Bedrooms filter
    if (bedrooms && bedrooms.length > 0) count++;

    // Bathrooms filter
    if (minNumBathrooms !== null) count++;

    // Building status filters
    if (buildingStatus.isVerified) count++;
    if (buildingStatus.isTopRated) count++;
    if (buildingStatus.isRentStabilized) count++;
    if (buildingStatus.hasBuildingGoodCauseEviction) count++;

    // Move-in date filter
    if (expectedMoveInDate.selections && expectedMoveInDate.selections.length > 0) count++;

    // Amenities filter (count if any amenity is selected)
    const hasAmenities = Object.values(amenities).some(value => value === true);
    if (hasAmenities) count++;

    // Compliances filter (count if any compliance is selected)
    const hasCompliances = Object.values(compliances).some(value => value === true);
    if (hasCompliances) count++;

    return count;
  }, [
    price,
    bedrooms,
    minNumBathrooms,
    buildingStatus,
    expectedMoveInDate,
    amenities,
    compliances,
  ]);

  const hasActiveFilters = activeFilterCount > 0;

  return { activeFilterCount, hasActiveFilters };
}
